import GenericAuthModal from '../../../Containers/Modals/Auth/GenericModal';
import SimplePopup from '../SimplePopup';
import React from 'react';
import { IMultiUserAuthPopupProps } from './types';

export const MultiUserAuthPopup: React.FC<IMultiUserAuthPopupProps> = ({ isShow, onClose, onSuccess }) => {
  const handleSuccessAuth = async () => {
    onClose();
    await onSuccess();
  };
  return (
    <SimplePopup show={isShow} close={onClose} isTransparent>
      <GenericAuthModal onSuccess={handleSuccessAuth} />
    </SimplePopup>
  );
};
